<template>
    <div class="min-h-screen w-full bg-gray-100 flex items-center justify-center dark:bg-dark-700">
        <div class="grid grid-cols-1 md:grid-cols-2 w-full max-w-6xl bg-white rounded-lg shadow-lg mx-5">

            <!-- Left Column: Image and Description -->
            <div class="hidden md:block p-6 rounded-lg md:rounded-l-lg md:rounded-r-none dark:bg-dark-800">
                <img src="@/assets/logo-kotak-sendowo.webp" alt="Logo" class="w-full h-full object-cover">
            </div>

            <!-- Right Column: Login Form -->
            <div class="p-6 bg-dark-900 dark:bg-dark-900 text-light-50 dark:text-dark-50 rounded-lg md:rounded-r-lg md:rounded-l-none">
                <h2 class="text-2xl font-bold text-center text-white mb-6">Login</h2>
                <span id="errorMessage" v-show="errorMessage"
                    class="text-red-700 w-full bg-red-300 font-medium px-3 py-2 rounded-md flex items-center">
                    <ExclamationTriangleIcon class="w-5 h-5 me-2" />
                    {{ errorMessage }}
                </span>
                <form @submit.prevent="handleLogin">
                    <!-- Email Field -->
                    <InputText id="user-email" v-model="email" type="text" label="Username"
                    label_class="text-white font-medium" placeholder="Username anda" input_class="w-full mb-5" />

                    <!-- Password Field -->
                    <InputPassword id="user-password" v-model="password" label="Password"
                    label_class="text-white block text-start font-medium" placeholder="Password anda" input_class="w-full mb-5" />

                    <!-- Submit Button -->
                    <div class="flex justify-center">
                        <button type="submit" class="w-full bg-primary text-white py-2 rounded-md hover:bg-hover-primary transition duration-300" @click="login">Login</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- <section class="bg-color-1 h-full">
        <div class="lg:px-20 sm:px-5 py-16 h-full">
            <div class="mb-20">
                <h1 class="text-3xl font-bold text-center text-white">Welcome to FOX POS</h1>
            </div>
            <div class="flex justify-center">
                <div class="grid grid-cols-2 gap-10 justify lg:w-3/4 sm:w-full">
                    <div class="flex justify-center">
                        <UserCard class="h-64 lg:w-3/4 sm:w-full" />
                    </div>
                    <div class="flex justify-between flex-col">
                        <span id="errorMessage" v-show="errorMessage"
                            class="text-red-700 w-full bg-red-300 font-medium px-3 py-2 rounded-md flex items-center">
                            <ExclamationTriangleIcon class="w-5 h-5 me-2" />
                            {{ errorMessage }}
                        </span>
                        <div>
                            <InputText id="user-email" v-model="email" type="email" label="Email"
                                label_class="text-white" placeholder="Email anda" input_class="w-full" />
                        </div>
                        <InputPassword id="user-password" v-model="password" label="Password"
                            label_class="mb-2 text-white block text-start" placeholder="Password anda" />
                        <div class="flex">
                            <SubmitButton id="submit" @click="login"
                                button_class="bg-color-4 px-5 py-2 text-sm font-semibold text-color-1 hover:bg-color-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-color-3"
                                button_name="Login" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import InputPassword from '@/components/form/InputPassword.vue';
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    name: 'AuthView',
    components: {
        InputPassword, InputText,
        ExclamationTriangleIcon
    },
    computed: {
        ...mapGetters('detail_user', ['detailUser']),
        ...mapGetters('role_permissions', ['allRolePermissions']),
        ...mapGetters('outlets', ['allOutlets'])
    },
    data() {
        return {
            email: '',
            password: '',
            errorMessage: '',
        }
    },
    async created() {
        await this.$store.dispatch('detail_user/fetchUser');
        if (localStorage) {
            this.$router.push('/dashboard');
        }
    },
    methods: {
        async login() {
            try {
                const response = await axios.post(`${process.env.VUE_APP_ROOT_API}/auth`, {
                    username: this.email,
                    password: this.password
                });

                if (response.data.status == 'success') {
                    const token = response.data.data.token;
                    localStorage.setItem('auth_token', token);

                    await this.$store.dispatch('detail_user/fetchUser');
                    const detailuser = await this.$store.dispatch('users/fetchUserById', this.detailUser.id);
                    if (detailuser.status == 'success') {
                        localStorage.setItem('outlet_id', detailuser.data.outlet_id);
                        localStorage.setItem('role_id', detailuser.data.role_id);
                        this.$router.push('/dashboard');
                    }
                } else {
                    this.errorMessage = response.data.message;
                }
            } catch (error) {
                console.log(error);
                this.errorMessage = 'Username atau Password salah';
            }
        }
    }
}
</script>